'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

export class MainController {
  $http;
  socket;
  awesomeThings = [];
  newThing = '';

  /*@ngInject*/
  constructor($http, $q, $scope, $state, Modal, Auth) {
    'ngInject';
    this.$http = $http;
    this.$q = $q;
    this.$state = $state;
    this.Modal = Modal;
    this.Auth = Auth;

    this.ready = false;
    this.route = 'main';

    this.form = {};
    this.systemOptions = [];
    this.result = {};
    this.pageSizeOptions = [10, 20, 30, 40, 50];
    this.sortByOptions = {
      favilityName: 'Facility Name',
      jobClass: 'Job Class',
      areaName: 'Area Name',
      assignmentStartDate: 'Assignment Start Date',
      createdDate: 'Created Date'
    };
    this.pagination = {
      _paging: true,
      _selector: 'All',
      _pageSize: 10,
      _pageNum: 1,
      _sortBy: 'createdDate desc'
    };
    this.tableMsg = '';

    $scope.$on('$destroy', function() {

    });
  }

  getSystems(extraParams) {
    let deferred = this.$q.defer();
    let self = this;
    let params = {
      _selector: 'name',
      _pageSize: 'All'
    };
    if(extraParams) {
      angular.extend(params, extraParams);
    }
    this.$http.get(`/api/types/systems`, { params: params })
      .then(function(response) {
        self.systemOptions = response.data;
        deferred.resolve();
      }, function(err) {
        deferred.resolve();
      });
    return deferred.promise;
  }

  buildQuery() {
    return angular.extend(angular.copy(this.form), this.pagination);
  }

  noPad(n, size) {
    var s = String(n);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  getData() {
    let self = this;
    this.$http.get('/api/orders', {
        params: this.buildQuery()
      })
      .then(function(response) {
        if(response.data.total === 0) {
          self.tableMsg = 'No record.';
        }
        if(response.data) {
          angular.forEach(response.data.items, function(item) {
            if(item.orderNo) {
              item.orderNo = self.noPad(item.orderNo, 5);
            }
          });
        }
        self.result = response.data;
      }, function(err) {

      });
  }

  search() {
    this.tableMsg = 'Searching....';
    this.getData();
  }

  clearSearch() {
    this.form = {};
    this.pagination._pageNum = 1;
    this.getData();
  }

  delete(item) {
    let self = this;
    this.Modal.confirm.delete(function() {
      self.$http.delete(`/api/orders/${item._id}`)
        .then(function(response) {
          self.getData();
        }, function(err) {

        });
    })(`${item.facilityName} / ${item.areaName} - ${item.quantity} ${item.jobClass} on ${item.assignmentStartDateStr}`);
  }

  resend(item) {
    let self = this;
    this.Modal.confirm.general(function() {
      self.$http.get(`/api/orders/email/${item._id}`);
    })(`Resend Email Confirmation`, `<p>Are you sure you want to resend this order email?</p>`);
  }

  rowNumb(idx) {
    return (idx + 1) + (this.result.pageNum !== 1 ? ((this.result.pageSize * this.result.pageNum) - this.result.pageSize) : 0);
  }

  updateSortBy(sortBy) {
    this.pagination._sortBy = sortBy;
    this.$state.go(this.route, this.buildQuery(), {notify: false});
    this.getData();
  }

  updatePageSize(pageSize) {
    this.pagination._pageSize = pageSize;
    this.pagination._pageNum = 1;
    this.$state.go(this.route, this.buildQuery(), {notify: false});
    this.getData();
  }

  gotoPage(pageNum) {
    this.pagination._pageNum = pageNum;
    this.$state.go(this.route, this.buildQuery(), {notify: false});
    this.getData();
  }

  $onInit() {
    let self = this;
    this.Auth.getCurrentUser(function(user) {
      if(user.role === 'admin') {
        self.ready = true;
        self.tableMsg = 'Loading....';
        self.getData();
      } else {
        self.$state.go('order');
      }
    });
  }

}

export default angular.module('wftOrderFormApp.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController,
    controllerAs: 'MainCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js